// FILE: src/components/PaceCoachStrip.js
//
// Non-blocking inline coaching strip. Renders a single pace message produced by
// usePaceInterventions. NEVER a modal: it sits below the exam header, the
// learner can keep answering, and it auto-dismisses (the hook clears the
// message) or can be dismissed manually. Presentational only.
//
// aria-live="polite" so screen readers announce it without stealing focus.

import React from 'react';
import css from './PaceCoachStrip.module.css';

export default function PaceCoachStrip({ message, onDismiss }) {
  if (!message) return null;

  return (
    <div
      className={css.strip}
      data-testid="pace-coach-strip"
      data-pace-message-type={message.type}
      role="status"
      aria-live="polite"
    >
      <span className={css.icon} role="img" aria-label="Pace coach">🧭</span>
      <span className={css.text}>{message.text}</span>
      <button
        type="button"
        className={css.dismiss}
        onClick={onDismiss}
        aria-label="Dismiss pace tip"
      >
        ×
      </button>
    </div>
  );
}
